import { Grid } from '@material-ui/core';
import React from 'react';
import "yet-another-react-lightbox/dist/styles.css";
import elo_hero_desktop from '../../assets/images/educational/elo/elo_hero_desktop.webp';
import elo_hero_mobile from '../../assets/images/educational/elo/elo_hero_mobile.webp';
import eloLogo from '../../assets/images/educational/elo/elo_logo.svg';
import Hero from '../Hero/Hero';
import OutlineButton from '../OutlineButton/OutlineButton';
import Typography from '../Typography/Typography';
import styles from './EloView.module.scss';

export default function EloView() {

    const heroImages = {
        xs: elo_hero_mobile,
        gtXs: elo_hero_desktop
    }

    return (
        <div className={styles.Wrapper}>
            <Hero images={heroImages} />
            <Grid container justify="center">
                <main>

                    <Grid container id={styles.Introduction}>
                        <Grid item xs={12} sm={4}>
                            <div className={styles.Logo}>
                                <img src={eloLogo} alt="logo do projeto elo" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={8} className={styles.Blurb}>
                            <Typography variant="RocGroteskMedium25">
                                O Coliseu Porto Ageas, a Irmandade dos Clérigos, a Área Metropolitana do Porto
                                e o Turismo do Porto e Norte de Portugal formam o novo “ELO”, o projeto cultural
                                e social que, desde 2023, trabalha a inclusão através da arte. A nova edição vai
                                decorrer entre outubro de 2025 e maio de 2026, tem como padrinho o encenador e
                                dramaturgo Tiago Rodrigues e vai dedicar-se ao tema da Adolescência. O objetivo
                                é dar voz aos mais jovens e abrir o debate sobre os desafios atuais da Adolescência.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container id={styles.Presentation}>
                        <Typography variant="RocGroteskRegular25">
                            A terceira edição do “ELO” cresce em número de áreas artísticas, cidades abrangidas e parceiros.
                            Às aulas de música, dança e teatro soma-se agora a criação plástica. O projeto vai organizar
                            também sessões de conversa nas Escolas Secundárias da Maia e de Gondomar, alargando a sua dimensão metropolitana.
                        </Typography>
                    </Grid>

                    <Grid container id={styles.Subpresentation}>
                        <Typography variant="RocGroteskRegular25">
                            Desde a sua criação, em 2023, que o “ELO” pretende simbolizar a ligação entre diferentes disciplinas
                            artísticas (música, teatro, dança, storytelling e, agora, criação plástica), setores (social e educativo)
                            e pessoas de diferentes idades e contextos sociais (público em geral, com e sem deficiência, alunos
                            do ensino secundário e a comunidade prisional, desde os reclusos aos guardas prisionais que com eles trabalham).
                        </Typography>
                    </Grid>

                    <Grid container justify="center" className={styles.Registration}>
                        <div>Últimas inscrições para jovens / adolescentes  - Teatro e Criação Plástica.</div>
                    </Grid>

                    <Grid container justify="center">
                        <p><OutlineButton route="https://docs.google.com/forms/d/e/1FAIpQLScfu__ecvXXbJ5Gl11RRZKhuhSsnktaLiCsx3tseibgLJ9ooA/viewform" name="Inscreva-se Aqui" /></p>
                    </Grid>

                </main>
            </Grid>
        </div>
    )
}
